export const columnsExcel = [
  { key: 'nombre', header: 'Nombre' },
  { key: 'descripcion', header: 'Descripción' },
  { key: 'estado', header: 'Estado' },
  { key: 'updatedAt', header: 'Última actualización' },
];
